/**
 * A metadata value that can be copied to clipboard.
 * Compare with frontends/app/src/components/CopyableText.tsx
 */

import {toast} from '@wandb/weave/common/components/elements/Toast';
import {Button} from '@wandb/weave/components/Button';
import copyToClipboard from 'copy-to-clipboard';
import React, {useCallback} from 'react';

import * as S from './MetadataValue.styles';

type CopyableTextProps = {
  text: string;
  copyText?: string;
  toastText?: string;
};

export const CopyableText = ({
  text,
  copyText,
  toastText,
}: CopyableTextProps) => {
  const copy = useCallback(() => {
    copyToClipboard(copyText ?? text);
    toast(toastText ?? 'Copied to clipboard');
  }, [text, copyText, toastText]);

  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    copy();
  };

  return (
    <S.MainPanel>
      <S.ContentPanel>{text}</S.ContentPanel>
      <S.ButtonPanel>
        <Button
          icon="copy"
          variant="ghost"
          onClick={onClick}
          tooltip="Copy to clipboard"
        />
      </S.ButtonPanel>
    </S.MainPanel>
  );
};
